import { ArrowRight, MapPin, Instagram } from "lucide-react";
import { BUSINESS, IMAGES } from "../data";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Luxury car dashboard with digital screens"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0C10] via-[#0A0C10]/85 to-[#0A0C10]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0C10] via-transparent to-[#0A0C10]/70" />
      </div>

      {/* Ambient glow */}
      <div
        aria-hidden="true"
        className="absolute top-1/3 -right-40 h-[520px] w-[520px] rounded-full bg-[#00F0FF]/20 blur-[140px] glow-pulse"
      />
      <div
        aria-hidden="true"
        className="absolute bottom-10 left-[20%] h-[300px] w-[300px] rounded-full bg-[#00A3FF]/15 blur-[120px] glow-pulse"
      />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-36 sm:pt-44 pb-16 min-h-[100svh] flex flex-col justify-between">
        <div className="max-w-3xl reveal">
          <div className="inline-flex items-center gap-2 border border-white/10 bg-white/[0.02] backdrop-blur-sm px-3 py-1.5 rounded-sm mb-8">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF] animate-pulse" />
            <span className="text-[11px] uppercase tracking-[0.24em] text-white/70">
              Mobile Auto Electrician · London E1
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading text-4xl sm:text-5xl lg:text-7xl font-medium text-white leading-[1.02] tracking-tighter"
          >
            Car electrics,{" "}
            <span className="text-gradient-cyan">done properly.</span>
          </h1>

          <p className="mt-6 max-w-xl text-base sm:text-lg text-[#9CA3AF] leading-relaxed">
            Wireless CarPlay. Digital dashes. Ambient starlights. GPS trackers
            and full security retrofits. Six years of specialist experience —
            fully mobile across London, jobs most others refuse.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              href={BUSINESS.whatsappText}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-whatsapp-cta"
              className="group inline-flex items-center gap-2 bg-[#00F0FF] hover:bg-[#33F3FF] text-[#0A0C10] font-semibold text-sm px-6 py-3.5 rounded-sm transition-all hover:shadow-[0_0_30px_rgba(0,240,255,0.3)]"
            >
              Get a quote on WhatsApp
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#services"
              data-testid="hero-services-cta"
              className="inline-flex items-center gap-2 border border-white/15 text-white hover:bg-white/5 px-6 py-3.5 rounded-sm text-sm font-medium transition-colors"
            >
              Browse services
            </a>
          </div>
        </div>

        {/* Meta row */}
        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6 border-t border-white/5 pt-8">
          <Stat label="Years Experience" value={BUSINESS.yearsExperience} />
          <Stat label="Services" value="15+" />
          <Stat label="Fully Mobile" value="Yes" />
          <Stat label="Crypto Accepted" value="Yes" />
        </div>

        {/* Location + Insta */}
        <div className="hidden lg:flex absolute right-12 top-36 flex-col items-end gap-2 text-[11px] uppercase tracking-[0.2em] text-white/50">
          <div className="flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5" />
            {BUSINESS.location}
          </div>
          <a
            href={BUSINESS.instagram}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 hover:text-[#00F0FF] transition-colors"
          >
            <Instagram className="h-3.5 w-3.5" />
            {BUSINESS.instagramHandle}
          </a>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="font-heading text-2xl sm:text-3xl text-white tracking-tight">
        {value}
      </div>
      <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-white/50">
        {label}
      </div>
    </div>
  );
}
